import { RouteLocationNormalized } from 'vue-router'

export default function stashPlayRedirect(to: RouteLocationNormalized): void {
  const play = to.query.play as string
  if (play) {
    localStorage.setItem('playRedirect', JSON.stringify({ play }))
  }
}
